/**
 * Palette — the fixed colours used by inline styles, MUI `sx` and SVG props.
 *
 * GENERATED by the design-token refactor (docs/knowledge/design-tokens.md), then
 * maintained by hand. Keys are EXACTLY the SCSS variable names in
 * src/variables/_palette.scss (plus the few _color.scss primitives call sites
 * reuse), so one search finds a colour in both languages:
 *
 *   SCSS  border: 1px solid $gray-88;
 *   TS    border: `1px solid ${palette["gray-88"]}`
 *
 * Values are plain hex / rgba() strings — safe for colour maths, canvas, PDF
 * and `<meta name="theme-color">`. Brand colours are deliberately absent: use
 * `colors.brand.*` from ./design-tokens (runtime partner-swappable CSS vars).
 * Amber / Error / Info / Success mirror _color.scss primitives that are tenant
 * tokens (`map-get($tokens, "system-*")`): the values here are the default
 * (_base = Zenvoya) build's. They do not follow REACT_APP_TENANT; the SCSS
 * variables do.
 *
 * palette.test.ts keeps this file and _palette.scss in sync.
 */
export const palette = {
  // _color.scss primitives reused by call sites
  "Amber": "#FF9500",
  "Error": "#FF3B30",
  "Info": "#007AFF",
  "Neutral-Darker": "#222222",
  "Neutral-Darkest": "#000000",
  "Success": "#34C759",
  "White": "#FFFFFF",
  // black
  "black-a3-1": "#00000008",
  "black-a4": "rgba(0, 0, 0, 0.04)",
  "black-a5": "rgba(0, 0, 0, 0.05)",
  "black-a5-9": "#0000000F",
  "black-a6": "rgba(0, 0, 0, 0.06)",
  "black-a7-8": "#00000014",
  "black-a8": "rgba(0, 0, 0, 0.08)",
  "black-a10": "rgba(0, 0, 0, 0.1)",
  "black-a12": "rgba(0, 0, 0, 0.12)",
  "black-a14-9": "#00000026",
  "black-a15": "rgba(0, 0, 0, 0.15)",
  "black-a18": "rgba(0, 0, 0, 0.18)",
  "black-a19": "rgba(0, 0, 0, 0.19)",
  "black-a20": "rgba(0, 0, 0, 0.2)",
  "black-a23": "rgba(0, 0, 0, 0.23)",
  "black-a30": "rgba(0, 0, 0, 0.3)",
  "black-a30-2": "#0000004D",
  "black-a40": "rgba(0, 0, 0, 0.4)",
  "black-a50": "rgba(0, 0, 0, 0.5)",
  // Theme Studio elevation scales (utils/partnerTheme.ts).
  "black-a3": "rgba(0, 0, 0, 0.03)",
  "black-a14": "rgba(0, 0, 0, 0.14)",
  "black-a16": "rgba(0, 0, 0, 0.16)",
  "black-a24": "rgba(0, 0, 0, 0.24)",
  // MUI's light-palette defaults, the fallbacks of the Theme Studio MUI overrides (App.tsx).
  "black-a11": "rgba(0, 0, 0, 0.11)",
  "black-a26": "rgba(0, 0, 0, 0.26)",
  "black-a54": "rgba(0, 0, 0, 0.54)",
  "black-a60": "rgba(0, 0, 0, 0.6)",
  "black-a87": "rgba(0, 0, 0, 0.87)",
  "gray-74": "#BDBDBD",
  "gray-21": "#363636",
  "black-a55": "rgba(0, 0, 0, 0.55)",
  "black-a70": "rgba(0, 0, 0, 0.7)",
  "black-a80": "rgba(0, 0, 0, 0.8)",
  "black-a85": "rgba(0, 0, 0, 0.85)",
  // white
  "white-a0": "rgba(255, 255, 255, 0)",
  "white-a10": "rgba(255, 255, 255, 0.1)",
  "white-a20": "rgba(255, 255, 255, 0.2)",
  "white-a30": "rgba(255, 255, 255, 0.3)",
  "white-a40": "rgba(255, 255, 255, 0.4)",
  "white-a45": "rgba(255, 255, 255, 0.45)",
  "white-a50": "rgba(255, 255, 255, 0.5)",
  "white-a55": "rgba(255, 255, 255, 0.55)",
  "white-a60": "rgba(255, 255, 255, 0.6)",
  "white-a65": "rgba(255, 255, 255, 0.65)",
  "white-a70": "rgba(255, 255, 255, 0.7)",
  "white-a75": "rgba(255, 255, 255, 0.75)",
  "white-a80": "rgba(255, 255, 255, 0.8)",
  "white-a85": "rgba(255, 255, 255, 0.85)",
  "white-a90": "rgba(255, 255, 255, 0.9)",
  "white-a95": "rgba(255, 255, 255, 0.95)",
  "white-a97": "rgba(255, 255, 255, 0.97)",
  // gray
  "gray-9": "#161616",
  "gray-10": "#1A1A1A",
  "gray-10-a8": "rgba(26, 26, 26, 0.08)",
  "gray-12": "#1F1F1F",
  "gray-13-a10": "rgba(34, 34, 34, 0.1)",
  "gray-14-5": "#252525",
  "gray-15-3": "#272727",
  "gray-18": "#2E2E2E",
  "gray-20": "#333333",
  "gray-22": "#393939",
  "gray-29": "#4A4A4A",
  "gray-33": "#555555",
  "gray-39-a20": "rgba(99, 99, 99, 0.2)",
  "gray-40-8": "#686868",
  "gray-41-a10": "rgba(105, 105, 105, 0.1)",
  "gray-41-a50": "rgba(105, 105, 105, 0.5)",
  "gray-41-2": "#696969",
  "gray-42": "#6B6B6B",
  "gray-53": "#888888",
  "gray-56": "#8F8F8F",
  "gray-59-a50": "rgba(151, 151, 151, 0.5)",
  "gray-59-a70": "rgba(151, 151, 151, 0.7)",
  "gray-59": "#979797",
  "gray-60": "#999999",
  "gray-60-8": "#9B9B9B",
  "gray-61-2": "#9C9C9C",
  "gray-61-6": "#9D9D9D",
  "gray-62": "#9E9E9E",
  "gray-65": "#A5A5A5",
  "gray-66": "#A9A9A9",
  "gray-67": "#ACACAC",
  "gray-69": "#B1B1B1",
  "gray-71": "#B6B6B6",
  "gray-73": "#BBBBBB",
  "gray-75": "#BEBEBE",
  "gray-75-7": "#C1C1C1",
  "gray-76-1": "#C2C2C2",
  "gray-76-9": "#C4C4C4",
  "gray-77-3": "#C5C5C5",
  "gray-78": "#C7C7C7",
  "gray-78-4": "#C8C8C8",
  "gray-79": "#CACACA",
  "gray-81": "#CFCFCF",
  "gray-81-6": "#D0D0D0",
  "gray-82": "#D1D1D1",
  "gray-83-5": "#D5D5D5",
  "gray-83-9": "#D6D6D6",
  "gray-84-7": "#D8D8D8",
  "gray-85-1": "#D9D9D9",
  "gray-85-5": "#DADADA",
  "gray-86": "#DCDCDC",
  "gray-87": "#DDDDDD",
  "gray-88": "#E0E0E0",
  "gray-88-6": "#E2E2E2",
  "gray-89": "#E4E4E4",
  "gray-89-8": "#E5E5E5",
  "gray-90-2": "#E6E6E6",
  "gray-91": "#E8E8E8",
  "gray-92-5": "#ECECEC",
  "gray-92-9": "#EDEDED",
  "gray-93-7": "#EFEFEF",
  "gray-94-1": "#F0F0F0",
  "gray-94-5": "#F1F1F1",
  "gray-94-9": "#F2F2F2",
  "gray-95-7": "#F4F4F4",
  "gray-96-1": "#F5F5F5",
  "gray-96-5": "#F6F6F6",
  "gray-97": "#F8F8F8",
  "gray-97-6": "#F9F9F9",
  "gray-98": "#FAFAFA",
  "gray-99": "#FDFDFD",
  "gray-100": "#FEFEFE",
  // slate
  "slate-11": "#1C1C1E",
  "slate-41": "#5F6A70",
  "slate-45-7": "#6C757D",
  "slate-46-1": "#6B7280",
  "slate-65": "#9CA3AF",
  "slate-66": "#A3A9AD",
  "slate-79": "#C7C7CC",
  // stone
  "stone-44": "#706F6F",
  "stone-48": "#7A7979",
  "stone-57": "#929090",
  "stone-68": "#B0AFAC",
  "stone-80-a10": "rgba(206, 200, 200, 0.1)",
  "stone-80": "#CCCACA",
  "stone-86": "#DDDCDC",
  // red
  "red-32": "#842029",
  "red-33": "#7B2C3B",
  "red-35": "#991B1B",
  "red-40-a80": "rgba(204, 9, 0, 0.8)",
  "red-40": "#CC0900",
  "red-40-v2": "#BF150D",
  "red-40-v3": "#CC0A00",
  "red-41": "#A32D2D",
  "red-46": "#D84315",
  "red-47": "#D31E1E",
  "red-49": "#C83232",
  "red-50": "#E11D48",
  "red-50-a60": "rgba(255, 0, 0, 0.6)",
  "red-50-6": "#D32F2F",
  "red-50-6-v2": "#DC2626",
  "red-55": "#E53935",
  "red-56-1": "#B5697A",
  "red-56-3": "#EA4335",
  "red-57": "#E53E3E",
  "red-58": "#F44336",
  "red-59": "#FC3A30",
  "red-63-a18": "rgba(235, 87, 87, 0.18)",
  "red-64": "#FF6347",
  "red-82": "#FCA5A5",
  "red-86-1": "#F5C2C7",
  "red-86-3": "#F7C1C1",
  "red-89": "#FECACA",
  "red-94-5": "#FBE9E7",
  "red-94-9": "#FFE5E5",
  "red-95-5": "#FCEBEB",
  "red-95-5-v2": "#FDECEA",
  "red-96": "#FFEBEA",
  "red-97": "#FEF2F2",
  "red-98": "#FFF4F4",
  // orange
  "orange-37": "#B45309",
  "orange-44": "#D97706",
  "orange-45": "#E65100",
  "orange-50": "#FF8C00",
  "orange-50-2": "#F59E0B",
  "orange-53": "#F97316",
  "orange-57": "#FFA726",
  "orange-61": "#E0A458",
  "orange-62": "#FBB040",
  // yellow
  "yellow-47": "#C9A227",
  "yellow-48": "#F5B400",
  "yellow-49": "#FCB400",
  "yellow-50": "#FFB800",
  "yellow-50-v2": "#FFD700",
  "yellow-50-2": "#FAB306",
  "yellow-50-2-v2": "#FBBC05",
  "yellow-51-a20": "rgba(255, 206, 7, 0.2)",
  "yellow-51-4": "#FFCE07",
  "yellow-51-4-v2": "#FFC107",
  "yellow-59": "#FCC333",
  "yellow-80": "#F3D9A4",
  "yellow-93-5": "#F5F1E8",
  "yellow-97": "#FFFAF0",
  // lime
  "lime-44": "#84CC16",
  "lime-59": "#ADFF2F",
  "lime-94": "#F1F8E9",
  // green
  "green-24": "#166534",
  "green-30": "#039627",
  "green-32": "#1F8539",
  "green-34": "#2E7D32",
  "green-36-3": "#16A34A",
  "green-36-5": "#558B2F",
  "green-41": "#28A745",
  "green-43": "#34A853",
  "green-44-5": "#43A047",
  "green-45-3": "#22C55E",
  "green-49": "#4CAF50",
  "green-50": "#7FFF00",
  "green-55": "#6FA88A",
  "green-83": "#C8E6C1",
  "green-88": "#D4EDDA",
  "green-93": "#DCFCE7",
  "green-94": "#E8F5E9",
  "green-95": "#EBF9EE",
  "green-97": "#F0FDF4",
  // teal
  "teal-23-7": "#0E6B6B",
  "teal-23-7-v2": "#1B5E3F",
  "teal-36": "#00B67A",
  "teal-41": "#00CED1",
  "teal-51": "#4FB3A8",
  "teal-55-a35": "rgba(86, 192, 190, 0.35)",
  "teal-55": "#56C0BE",
  // sky
  "sky-10": "#002134",
  "sky-29": "#095A8B",
  "sky-39": "#00B3C5",
  "sky-43": "#06B6D4",
  "sky-45": "#2596BE",
  "sky-46": "#1FBCCC",
  "sky-50": "#00B7FF",
  "sky-50-v2": "#00BFFF",
  "sky-52": "#27A9E0",
  "sky-53": "#3498DB",
  "sky-55": "#32ADE6",
  "sky-60": "#46BCEC",
  "sky-70": "#7CBEEA",
  "sky-79": "#A4D1F0",
  "sky-88": "#D0E8F0",
  "sky-92": "#D8EFFF",
  "sky-94": "#E8F4F8",
  "sky-98": "#F7FCFF",
  // blue
  "blue-7": "#010421",
  "blue-11": "#111827",
  "blue-16-9": "#1F2937",
  "blue-17-5": "#1E293B",
  "blue-18": "#0B3353",
  "blue-22": "#0F3D63",
  "blue-28-a50": "rgba(21, 78, 121, 0.5)",
  "blue-28-a25": "rgba(50, 50, 93, 0.25)",
  "blue-33-7": "#205C8C",
  "blue-34-1": "#4B5563",
  "blue-35": "#0056B3",
  "blue-41-8": "#1B75BA",
  "blue-42-4": "#1D75BB",
  "blue-46": "#1976D2",
  "blue-47": "#64748B",
  "blue-50": "#007BFF",
  "blue-51-6": "#4054C7",
  "blue-52": "#0A84FF",
  "blue-54": "#4A8FC7",
  "blue-58": "#5469D4",
  "blue-61-a20": "rgba(66, 133, 244, 0.2)",
  "blue-61": "#4285F4",
  "blue-65": "#94A3B8",
  "blue-73": "#A0A8D4",
  "blue-76": "#91C6F1",
  "blue-78": "#9FCBEE",
  "blue-84": "#D1D5DB",
  "blue-88": "#DCDCE6",
  "blue-89": "#C7D2FE",
  "blue-90-8": "#D0EBFF",
  "blue-91": "#E5E7EB",
  "blue-93": "#E9ECEF",
  "blue-94": "#E3F2FD",
  "blue-95": "#E5F2FF",
  "blue-95-9": "#F2F2F7",
  "blue-95-9-v2": "#F3F4F6",
  "blue-95-9-v3": "#F2F4F7",
  "blue-96-a80": "rgba(244, 246, 248, 0.8)",
  "blue-96-5": "#F4F6F8",
  "blue-97-6": "#F8F9FA",
  "blue-97-8": "#F8F8FB",
  "blue-98": "#F9FAFB",
  // purple
  "purple-23": "#2D0073",
  "purple-41": "#5A00D1",
  "purple-44": "#694797",
  "purple-46": "#7A1BD2",
  "purple-48": "#6A00F5",
  "purple-50": "#7300FF",
  "purple-50-4": "#6D28D9",
  "purple-51": "#5E17EB",
  "purple-53": "#8A2BE2",
  "purple-56": "#6C3CE1",
  "purple-57-8": "#7C3AED",
  "purple-57-8-v2": "#8830F7",
  "purple-59": "#7B2CFF",
  "purple-63": "#7950F2",
  "purple-65": "#A855F7",
  "purple-70": "#C47CEA",
  "purple-85": "#C4B5FD",
  "purple-91-6": "#E0D4FF",
  "purple-91-8": "#E9D5FF",
  "purple-94": "#ECDEFF",
  "purple-96": "#F5EDFF",
  "purple-97-1": "#F6F0FF",
  "purple-97-1-v2": "#F5F0FF",
  "purple-98": "#FBF7FF",
  // pink
  "pink-19": "#47174C",
  "pink-38": "#AD1457",
  "pink-43": "#C2185B",
  "pink-52": "#E91E63",
  "pink-54": "#FF1493",
  "pink-71": "#FF69B4",
  // added when the last raw colours were tokenised (exact values)
  "gray-85-9": "#DBDBDB",
  "gray-85-a50": "rgba(216, 216, 216, 0.5)",
  "stone-76": "rgb(197 191 191)",
  "slate-27": "#334155",
  "slate-69": "#A0AEC0",
  "blue-28": "#32325D",
  "sky-56": "#3BB2E3",
  "red-46-7": "#C4312A",
  "red-52-a20": "rgba(202, 61, 61, 0.2)",
} as const;

export type PaletteToken = keyof typeof palette;
